import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Megaphone } from 'lucide-react';

export const Route = createFileRoute('/admin-console/platform-content/whats-new')({
    staticData: {
        permissions: ['admin_content:read'],
        breadcrumb: {
            title: "What's new",
        },
        ui: {
            icon: Megaphone,
            title: "What's new",
            menuDescription: 'Manage the release announcements shown in the tenant console',
        },
    },
    component: Outlet,
});
